import React from 'react';
import cn from 'classnames';
import Card, { CardHeader } from '../../../../../components/Card';
import styles from './index.module.scss';

const CardTemplate = ({ className, ...props }) => {
  return <Card {...props} className={cn(styles.root, className)} />;
};

const Header = ({ className, ...props }) => {
  return <CardHeader {...props} className={cn(styles.header, className)} />;
};

CardTemplate.Header = Header;

export default CardTemplate;
